import { Component, ElementRef, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { DashboardService } from '../../services/dashboard.service';
import * as Chart from 'chart.js';

@Component({
  selector: '',
  template: '',
})
export class LineChartHandler implements OnInit {
  @Input() lineChartData: any;
  @Input() lineChartOptions: any;
  @Input() lineChartPlugins: any[] = [];
  @Input() lineChartType: string;

  @ViewChild('lineChartCanvas', { static: true }) chartCanvas: ElementRef;
  chartInstance: any;

  constructor(public service: DashboardService) {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.renderChart();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['lineChartData'] || changes['lineChartOptions']) && this.chartCanvas) {
      this.renderChart();
    }
  }

  renderChart(): void {
    if (!this.chartCanvas || !this.chartCanvas.nativeElement) return;

    if (this.chartInstance) {
      this.chartInstance.destroy();
    }

    if (!this.lineChartData || !this.lineChartData.labels || !this.lineChartData.datasets) return;

    this.chartInstance = new Chart(this.chartCanvas.nativeElement, {
      type: this.lineChartType,
      data: this.lineChartData,
      options: this.lineChartOptions,
      plugins: this.lineChartPlugins,
    });
  }

  ngOnDestroy(): void {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
    this.service.clear();
  }
}
